import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'positiveDecimal',
})
export class PositiveDecimalPipe implements PipeTransform {
	transform(value: number | undefined | null, ...args: unknown[]): string {
		if (value != undefined) {
			let number = Number(value);
			if (number >= 0) {
				return number > 0 ? `+ ${number.toFixed(2)}` : `${number.toFixed(2)}`;
			} else {
				let replacedValue = number.toFixed(2).replace('-', ``);
				return `- ${replacedValue}`;
			}
		} else return '-.--';
	}
}
